import React from 'react';
import { DialogSlideProps } from '../Objects/interfaces/AppInterface';
import useTailwindBrand from '../Theme/useTailwindBrand';
import ButtonField from './Ui/ButtonField';
import CopyCodeField from './Fields/CopyCodeField';


const DialogSlide = ({ message, linkText, onLinkClick, code, onClose, isCopy, onCopy }: DialogSlideProps) => {
    const { classes, common, brandConfig } = useTailwindBrand()
    return (
        <div className="space-y-6">
            <p className={common.body}>
                {message}{" "}
                <span onClick={onLinkClick} className={`${common.body} underline cursor-pointer`}>
                    {linkText}
                </span>
            </p>
            <CopyCodeField text={code} isCopy={isCopy} onCopy={onCopy} classes={classes} brandConfig={brandConfig} />
            <div className="flex gap-x-4 pt-6 py-4 justify-between">
                <ButtonField
                    label='Fermer'
                    onClick={onClose}
                    className='w-full'
                    variant='contained'
                />
            </div>
        </div>
    );
};

export default DialogSlide;